import { useUserStore } from '../stores/UserStore';

export const useUserFeatureFlags = () => {
	const featureFlags = useUserStore(state => state.featureFlags);

	return featureFlags;
};
